import { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import messages from '../../../constants/messages';

import { fetchAnimalsTags } from '../../../redux/actions/animal';
import { fetchGrazingData } from '../../../redux/actions/grazing';
import { setMapData } from '../../../redux/reducers/map';

import Map from '../../../components/Maps/MapsAll';
import { errorToastHandler } from '../../../components/action_notifier';

function LivestockLocation() {
  const history = useHistory();
  const dispatch = useDispatch();

  const { data: grazing } = useSelector(state => state.grazing);
  const { list: farms } = useSelector(state => state.farm);
  const { tags } = useSelector(state => state.animal);

  useEffect(() => {
    getAnimalTags();
  }, [dispatch]);

  useEffect(() => {
    storeMapData(farms);
    getGrazingData();
  }, [farms, tags]);

  async function getAnimalTags() {
    try {
      await dispatch(fetchAnimalsTags({ only_notifications: false })).unwrap();
    } catch (error) {
      errorToastHandler(error?.message || error?.response?.data?.message || messages.FAILED_ON_FETCH_DATA);
    }
  }

  async function getGrazingData() {
    if (!farms) return;

    const geofences = farms?.flatMap(geo => geo.geofences);
    const rotationIds = geofences?.map(g => (g.currentRotation ? g.currentRotation.id : g.lastRotation?.id));

    if (!rotationIds?.length) return;

    try {
      await dispatch(fetchGrazingData({ rotationIds })).unwrap();
    } catch (error) {
      errorToastHandler(error?.message || error?.response?.data?.message || messages.FAILED_ON_FETCH_DATA);
    }
  }

  function storeMapData(data) {
    if (!data?.length) return;

    const farms = data?.map(farm => farm.master_geofence);
    const geofences = data?.flatMap(geo => geo.geofences);
    const sites = data?.flatMap(geo => geo.sites);

    dispatch(
      setMapData({
        tracking: {
          ...tags,
          features: tags?.features?.map(f => ({ ...f, properties: { ...f.properties, isVisible: true } }))
        },
        farms,
        geofences: geofences?.filter(g => !g.is_master),
        sites,
        selected: []
      })
    );
  }

  const setAnimal = useCallback(id => history.push(`/tracking/${id}`), [history]);

  return <Map grazing={grazing} onAnimalClick={setAnimal} />;
}

export default memo(LivestockLocation);
